import React, { useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Avatar,
  Button,
  useTheme,
  Divider,
} from "@mui/material";
import { Phone, LocationOn, Language } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserByType } from "../redux/slices/user/thunk";
import LoadingComponent from "../components/LoadingComponent";
import Logo from "../assets/Logo.png"; // Logo path

const ContactUs = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const admins = useSelector((state) => state.usersSlice.usersByType);
  const loading = useSelector((state) => state.usersSlice.usersLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserByType({ type: "admin" }));
  }, [dispatch]);

  if (loading) {
    return (
      <Container
        maxWidth="md"
        sx={{ py: 8, display: "flex", justifyContent: "center" }}
      >
        <LoadingComponent />
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Logo & Header */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <img src={Logo} alt="Logo" style={{ maxWidth: 140, marginBottom: 4 }} />
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ marginBottom: 8 }}
        >
          {t("productiveFamiliesMarket")}
        </Typography>

        {/* Organization link under logo text */}
  {/* <Button
    variant="text"
    color="primary"
    href="https://tanmia-amwah.sa/"
    target="_blank"
    rel="noopener noreferrer"
    startIcon={<Language sx={{ml:1}} />}
    sx={{
      mb: 2,
      fontWeight: "medium",
      textTransform: "none",
      fontSize: "0.95rem",
    }}
  >
   www.tanmia-amwah.sa
  </Button> */}
  
        <Typography variant="h3" component="h1" gutterBottom>
          {t("contactUs.title")}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {t("contactUs.subtitle")}
        </Typography>
      </Box>

      {/* Admin Cards */}
      <Grid container spacing={3}>
        {admins.map((admin) => (
          <Grid item xs={12} key={admin._id}>
            <Paper
              elevation={3}
              sx={{ borderRadius: 2, overflow: "hidden", p: 3 }}
            >
              <Grid container spacing={3} alignItems="center">
                {/* Avatar */}
                <Grid item xs={12} sm={4} sx={{ textAlign: "center" }}>
                  <Avatar
                    src={admin.image}
                    sx={{
                      width: 120,
                      height: 120,
                      margin: "auto",
                      border: `3px solid ${theme.palette.primary.main}`,
                    }}
                  >
                    {!admin.image && admin.userName.charAt(0)}
                  </Avatar>
                </Grid>

                {/* Info */}
                <Grid item xs={12} sm={8}>
                  <Typography variant="h5" gutterBottom>
                    {admin.userName}
                  </Typography>

                  {admin.description && (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      gutterBottom
                    >
                      {admin.description}
                    </Typography>
                  )}

                  <Divider sx={{ my: 1.5 }} />

                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Phone sx={{ ml: 1, color: theme.palette.primary.main }} />
                    <Typography variant="body1">
                      {admin.countryCode ? `${admin.countryCode} ` : ""}
                      {admin.phoneNumber}
                    </Typography>
                  </Box>

                  {admin.address && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <LocationOn
                        sx={{ ml: 1, color: theme.palette.primary.main }}
                      />
                      <Typography variant="body1">{admin.address}</Typography>
                    </Box>
                  )}

                  {/* Call Button */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                    href={`tel:${admin.countryCode}${admin.phoneNumber}`}
                    startIcon={<Phone sx={{ ml: 1 }} />}
                  >
                    {t("contactUs.call")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Website Link */}
      <Box
        sx={{
          mt: 6,
          textAlign: "center",
          p: 4,
          borderRadius: 3,
          backgroundColor:
            theme.palette.mode === "light" ? "#f9f9f9" : "#1e1e1e",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: 2,
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: theme.palette.text.primary }}
        >
          {t("contactUs.visitSite")}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          href="https://tanmia-amwah.sa/"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<Language sx={{ ml: 1 }} />}
          sx={{
            px: 4,
            py: 1.5,
            fontWeight: "bold",
            textTransform: "none",
            fontSize: "1rem",
            borderRadius: "30px",
          }}
        >
         www.tanmia-amwah.sa
        </Button>
      </Box>
    </Container>
  );
};

export default ContactUs;
